export const expandRowAction =
  (
    changeFormState?: (
      state: boolean | ((prevState: boolean) => boolean)
    ) => void
  ): (() => void) =>
  () => {
    if (changeFormState) {
      changeFormState(false);
    }
  };
